var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLoader(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 44.555,
    height: 51.448,
    viewBox: "0 0 44.555 51.448",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2100",
    "data-name": "Rectangle 2100",
    width: 44.555,
    height: 51.448,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1557",
    "data-name": "Path 1557",
    d: "M51.77,59.779Z",
    transform: "translate(-51.77 -59.778)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2099",
    "data-name": "Rectangle 2099",
    width: 18.314,
    height: 18.314,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Loader",
    transform: "translate(-22.722 -19.276)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1548",
    "data-name": "Path 1548",
    d: "M0,55.613,22.278,42.751,0,29.889Z",
    transform: "translate(22.722 2.249)",
    fill: "#1e8efc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1549",
    "data-name": "Path 1549",
    d: "M51.77,42.751h0L74.048,55.613V29.889Z",
    transform: "translate(-6.77 2.249)",
    fill: "#1969c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1550",
    "data-name": "Path 1550",
    d: "M22.278,0,0,12.862,22.278,25.724h0Z",
    transform: "translate(22.722 19.276)",
    fill: "#78bbfd",
    opacity: 0.996
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1551",
    "data-name": "Path 1551",
    d: "M51.77,0V25.724L74.048,12.862Z",
    transform: "translate(-6.77 19.276)",
    fill: "#75a5df"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1552",
    "data-name": "Path 1552",
    d: "M0,72.641,22.278,85.5V59.779Z",
    transform: "translate(22.722 -14.778)",
    fill: "#2d70b2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1553",
    "data-name": "Path 1553",
    d: "M51.77,85.5,74.048,72.641,51.77,59.779Z",
    transform: "translate(-6.77 -14.778)",
    fill: "#2a5a94"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1554",
    "data-name": "Path 1554",
    d: "M51.77,59.778h0Z",
    transform: "translate(-6.77 -14.778)",
    fill: "#1e8efc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1555",
    "data-name": "Path 1555",
    d: "M51.77,59.778h0Z",
    transform: "translate(-6.77 -14.778)",
    fill: "#1e8efc"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1431",
    "data-name": "Group 1431",
    transform: "translate(22.722 19.276)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1430",
    "data-name": "Group 1430",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1423",
    "data-name": "Group 1423",
    transform: "translate(22.277 25.724)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1422",
    "data-name": "Group 1422"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1421",
    "data-name": "Group 1421",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1556",
    "data-name": "Path 1556",
    d: "M51.77,59.779Z",
    transform: "translate(-51.77 -59.779)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1426",
    "data-name": "Group 1426",
    transform: "translate(22.277 25.724)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1425",
    "data-name": "Group 1425"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1424",
    "data-name": "Group 1424",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1558",
    "data-name": "Path 1558",
    d: "M51.77,59.779Z",
    transform: "translate(-51.77 -59.779)",
    fill: "#444"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1429",
    "data-name": "Group 1429",
    transform: "translate(13.121 16.567)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1428",
    "data-name": "Group 1428"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1427",
    "data-name": "Group 1427",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1560",
    "data-name": "Path 1560",
    d: "M48.8,47.656A9.157,9.157,0,1,1,39.647,38.5,9.157,9.157,0,0,1,48.8,47.656",
    transform: "translate(-30.491 -38.499)",
    fill: "#fff"
  })))))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2101",
    "data-name": "Rectangle 2101",
    width: 44.555,
    height: 51.448,
    transform: "translate(22.722 19.276)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    from: "0 25 25",
    to: "360 25 25",
    dur: "0.5s",
    repeatCount: "indefinite"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoader);
export default __webpack_public_path__ + "static/media/loader.21449f0446e7ca495fd0ed9f04e702bf.svg";
export { ForwardRef as ReactComponent };